import styled from 'styled-components'

export const Container = styled.section`
    .tox-tinymce{
        height: 60vh !important;
    }
`
